import { render } from "./SlideAside.vue?vue&type=template&id=52864680&scoped=true&ts=true"
import script from "./SlideAside.vue?vue&type=script&lang=ts"
export * from "./SlideAside.vue?vue&type=script&lang=ts"

import "./SlideAside.vue?vue&type=style&index=0&id=52864680&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52864680"]])

export default __exports__